import bing from './tools/bing/init';
import facebook from './tools/facebook/init';
import ga4 from './tools/ga4/init';
import plausible from './tools/plausible/init';
import snowplow from './tools/snowplow/init';

const initMethods = [
  ga4.init,
  plausible.init,
  snowplow.init,
  bing.init,
  facebook.init,
];

function init() {
  initMethods.forEach((initMethod) => {
    initMethod();
  });
}

export default {
  init,
};
